module.exports = __webpack_public_path__ + "img/exit-fullscreen.b74c52ba.svg";